// possible agreement types — const object (not enum) because two crypto
// agreement keys intentionally share the same PDF URL.
export const AgreementType = {
  alpacax_crypto_agreement:
    "https://files.alpaca.markets/disclosures/library/Crypto%20Customer%20Agreement.pdf",
  crypto_agreement:
    "https://files.alpaca.markets/disclosures/library/Crypto%20Customer%20Agreement.pdf",
  customer_agreement:
    "https://files.alpaca.markets/disclosures/library/AcctAppMarginAndCustAgmt.pdf",
} as const;

export type AgreementType = (typeof AgreementType)[keyof typeof AgreementType];
